/**
 * A live recall in the reserved colour — the recall detail's header and the product
 * detail's banner. Renders nothing unless the recall row is `active`, so this file's
 * `RECALL_ALLOWLIST` entry covers a recall that exists and nothing else.
 */
import type { ReactNode } from "react";

import { Surface } from "@packagepage/ui";

export function LiveRecallBanner({
  recall,
  label,
  children,
}: {
  recall: { readonly status: string };
  label: string;
  children: ReactNode;
}): ReactNode {
  if (recall.status !== "active") return null;
  return (
    <Surface tone="recall" emphasis="led" data-screen-label={label}>
      {children}
    </Surface>
  );
}
